import * as React from 'react';
import { useState } from 'react';
import { Slider } from '@mui/material';
import { TRangeSliderFilter } from './RangeSliderFilter.types';
import './RangeSliderFilter.styled.scss';

export const RangeSliderFilter: TRangeSliderFilter = ({
  minPrice,
  maxPrice,
  label,
  onChange,
  defaultValue = [minPrice, maxPrice],
}) => {
  const [priceRange, setPriceRange] = useState<number[]>(defaultValue);

  const handleChange = (event: Event, newValue: number | number[]) => {
    setPriceRange(newValue as number[]);
    onChange(newValue as number[]);
  };

  return (
    <div className="range-slider-filter">
      <h6 className="range-slider-filter__label">
        {label}: {priceRange[0]}zl. - {priceRange[1]}zl.
      </h6>

      <div className="range-slider-filter__slider">
        <Slider
          value={priceRange}
          onChange={handleChange}
          valueLabelDisplay="auto"
          className="range-slider-filter__slider-component"
          min={minPrice}
          max={maxPrice}
          marks={[
            { value: minPrice, label: `${minPrice}zl` },
            { value: maxPrice, label: `${maxPrice}zl` },
          ]}
        />
      </div>
    </div>
  );
};
